<template>
  <div>
    <v-data-table
      :headers="familiarizationListHeaders"
      :items="acknowledgmentList"
      :items-per-page="-1"
      hide-default-footer
      :loading="$loading.isLoading('acknowledgmentList')"
      density="compact">
      <template #item.user="{ item }">
        {{ getPersonName(item.user) || '---' }}
      </template>
      <template #item.dateAccept="{ item }">
        {{
          item?.dateAccept
            ? new CustomDate(item.dateAccept).toString({ time: true })
            : '---'
        }}
      </template>
      <template #item.isAccept="{ item }">
        <span>{{ item.isAccept ? 'Так' : 'Ні' }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { useAcknowledgment } from './index'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { familiarizationListHeaders } from '@/utils/tableHeaders'

export default {
  name: 'Acknowledgment',
  data() {
    return { familiarizationListHeaders }
  },
  methods: { CustomDate, getPersonName },
  setup() {
    const { acknowledgmentList } = useAcknowledgment()
    return { acknowledgmentList }
  },
}
</script>

<style scoped lang="scss"></style>
